import { observer } from 'mobx-react-lite';
import { PermutiveScript } from '@menu/core/constants';
import { ContextProps } from '@menu/core/types';
import { useEffectOnce, useScript } from '@menu/core/hooks';
import { determineIfLoggedIn } from '@menu/core/lib';
import ConnectApi from '@menu/core/services/legacy/connect.api';
import MobileSideNav from './mobile/mobile-side-nav';
import MobileTopNav from './mobile/mobile-top-nav';
import { ProfileMenu, Search } from './shared';
import DesktopNav from './desktop/desktop-nav';
import useMenuActions from './use-menu-actions';

const Menu = observer((props: ContextProps) => {
  const { context } = props;

  const { closeSearch, selectHeaderLink } = useMenuActions(context);

  if (!context.config.ciamFlag) {
    useScript(PermutiveScript.tag);
  }

  useEffectOnce(() => {
    if (context.skipAuthValidation) {
      return;
    }

    const onload = async () => {
      if (context.config.ciamFlag) {
        return;
      }

      await new ConnectApi(context).redeemAuthTokenAsync();

      determineIfLoggedIn(context);
    };

    onload();
  });

  return (
    <>
      <DesktopNav context={context} />

      <MobileTopNav context={context} />

      <MobileSideNav context={context} onSelectHeaderLink={selectHeaderLink} />

      <Search context={context} onClose={closeSearch} />

      <ProfileMenu context={context} />
    </>
  );
});

export default Menu;
